import generateClassNames from '@/utils/generate-class-names'
import clsx from 'clsx'
import React, { forwardRef } from 'react'
import './icon-button.scss'

const classes = generateClassNames('btn-icon', [])

export interface IconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: 'sm' | 'md' | 'lg'
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  function IconButton(props, ref) {
    const { children, className, size = 'md', ...other } = props

    return (
      <button
        ref={ref}
        className={clsx(classes.root, `btn-icon--${size}`, className)}
        {...other}
      >
        {children}
      </button>
    )
  }
)

export default IconButton
